<template>
	<a-dialog class="privacy">
		<div v-html="$t('privacy')"></div>
		<a-button slot="actions" class="" secondary @click="$router.go(-1)">
			<div>{{ $t("backButton") }}</div>
		</a-button>
	</a-dialog>
</template>

<script>
import aDialog from "@/components/Dialog";
import aButton from "@/components/Button";

export default {
	components: {
		aDialog,
		aButton
	},
	i18n: {
		messages: {
			en: {
				backButton: "Back to previous page"
			}
		}
	}
};
</script>

<style lang="scss">
.privacy {
	max-width: 922px;
}
</style>
